import { useMutation } from "@apollo/client";
import { UPDATE_ASSESSMENT_STATUS } from "./graphql";
import { Alert } from "components/base/Toast";
import { parseError } from "apollo";
import Button from "components/base/Button";

const StartSelfAssessmentView = ({ id, dismiss }) => {
  const [updateAssessmentStatus, updateAssessmentStatusRes] = useMutation(
    UPDATE_ASSESSMENT_STATUS,
    {
      variables: {
        id,
        status: "self_assessment",
      },
      onCompleted() {
        Alert("success", "Status updated.");
        dismiss();
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  return (
    <div className="space-y-6">
      <div className="text-sm">
        Once you start self assessment, the system will notify the supplier and
        the assessment will change to `Self Assessment` status. Suppliers are
        supposed to provide self assessment at this stage.
      </div>

      <hr />

      <div>
        <Button
          primary
          onClick={updateAssessmentStatus}
          loading={updateAssessmentStatusRes.loading}
        >
          Start Self Assessment
        </Button>
      </div>
    </div>
  );
};

export default StartSelfAssessmentView;
